import { render, staticRenderFns } from "./template.html?vue&type=template&id=3d40f18e&scoped=true&"
import script from "./FormKeywordRecommend.vue?vue&type=script&lang=ts&"
export * from "./FormKeywordRecommend.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=3d40f18e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d40f18e",
  null
  
)

export default component.exports